import React, { useEffect, useState } from "react";
import { getStoreStatus } from "../lib/hours";

export const StoreStatusBadge = () => {
    const [status, setStatus] = useState(() => getStoreStatus());
    useEffect(() => {
        const t = setInterval(() => setStatus(getStoreStatus()), 60000);
        return () => clearInterval(t);
    }, []);

    const { open, label, closesAt, opensAt } = status;
    const dot = open ? "bg-emerald-400" : "bg-red-500";
    const tip = open ? `Κλείνει ${closesAt}` : opensAt ? `Ανοίγει ${opensAt}` : "";

    return (
        <span
            data-testid="store-status-badge"
            title={tip}
            className={`hidden sm:inline-flex items-center gap-2 px-2.5 py-1 border rounded-sm text-[11px] font-heading uppercase tracking-widest ${
                open ? "border-emerald-400/40 text-emerald-400 bg-emerald-400/5" : "border-red-500/40 text-red-400 bg-red-500/5"
            }`}
        >
            <span className={`relative flex h-2 w-2`}>
                {open && <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${dot}`} />}
                <span className={`relative inline-flex rounded-full h-2 w-2 ${dot}`} />
            </span>
            {label}
        </span>
    );
};
